export const QA_NAME_CALENDAR_FOLLOW_UP_CAP_MODAL = 'calendarFollowUpCap'
